module.exports = __webpack_public_path__ + "static/img/问界M7 Ultra.5d849a97.png";